import React, { useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";

const EmailBreachUsersHistory = () => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  //  Search State
  const [searchEmail, setSearchEmail] = useState("");

  // API CALL
  const fetchData = async (email = "") => {
    setLoading(true);

    try {
      const token = localStorage.getItem("userToken");

      let url = `${api_url}/breach-check/history`;

      //  Email add in URL
      if (email) {
        url += `?email=${email}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      setData(result.data?.items || []);
    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      setLoading(false);
    }
  };

  //  Search Button
  const handleSearch = () => {
    if (!searchEmail) return;

    fetchData(searchEmail);
  };

  //  TABLE COLUMNS
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "compromised",
        header: "Compromised",
        cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
      },
      {
        accessorKey: "breaches",
        header: "Breaches",
        cell: ({ getValue }) =>
          Array.isArray(getValue()) ? getValue().join(", ") : "-",
      },
    ],
    []
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4">
      <h3>{t("AllUsersBreachHistory")}</h3>

      {/* ✅ SEARCH BAR */}
      <div className="d-flex gap-2 mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search Email"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
        />

        <button className="btn btn-primary" onClick={handleSearch}>
          Search
        </button>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((header) => (
                    <th key={header.id}>
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EmailBreachUsersHistory;